import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-dot',
  templateUrl: './app-dot.component.html',
  styleUrls: ['./app-dot.component.scss'],
})
export class AppDotComponent {
  @Input() type: string;
  @Input() label: string;

  constructor() {}

  defineAppDotClass() {
    switch (this.type) {
      case 'success':
        return 'clsDot_dark_mint';
      case 'error':
      case 'failed':
        return 'clsDot_critical';
      case 'warning':
      case 'inprogress':
      case 'running':
      case 'unknown':
        return 'clsDot_medium';
    }
  }
}
